import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UrbisoftMainStructureComponent} from './components/urbisoft-main-structure/urbisoft-main-structure.component';
import {SidenavComponent} from './components/sidenav/sidenav.component';
import {HeaderComponent} from './components/header/header.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
import {NgxSpinnerModule} from 'ngx-spinner';



@NgModule({
  declarations: [UrbisoftMainStructureComponent, SidenavComponent, HeaderComponent],
  exports: [
    UrbisoftMainStructureComponent
  ],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatSidenavModule,
        MatListModule,
        MatInputModule,
        RouterModule,
        MatMenuModule,
        NgxSpinnerModule
    ]
})
export class UrbisoftMainStructureModule {
}
